import { connect } from "react-redux"
import { Dispatch } from "redux"
import {
  partialUpdateChannelProfile,
  reset,
  fetchChannelProfile,
  addDrafts,
  addEpisodes,
  appendChannelFollowers,
  unmountChannelFollowers,
  updateLiveSchedules,
} from "../../actions/pages/channelActionCreator"
import { getCurrentUser } from "../../libs/get-current-user"
import { RootState, ReduxAction } from "../../reducers"
import { IRootPagesState } from "../../reducers/pages"
import { ChannelProfile } from "../../rpcs/dist/ChannelRPC"
import { ChatRoom } from "../../rpcs/dist/ChatRoomRPC"
import { Episode } from "../../rpcs/dist/EpisodeRPC"
import { User } from "../../rpcs/dist/UserRPC"

export interface IChannelContainerProps {
  currentUser: User | null
  actions: ActionDispatcher
  channel: IRootPagesState["channel"]
}

export class ActionDispatcher {
  constructor(private dispatch: (action: ReduxAction) => void) {}

  public fetchChannelProfile(channelProfile: ChannelProfile) {
    this.dispatch(fetchChannelProfile(channelProfile))
  }

  public partialUpdateChannelProfile(channelProfile: Partial<ChannelProfile>) {
    this.dispatch(partialUpdateChannelProfile(channelProfile))
  }

  public updateEpisodes(episodes: Episode[]) {
    this.dispatch(addEpisodes(episodes))
  }

  public updateDrafts(episodes: Episode[]) {
    this.dispatch(addDrafts(episodes))
  }

  public appendChannelFollowers(followers: User[]) {
    this.dispatch(appendChannelFollowers(followers))
  }

  public unmountChannelFollowers() {
    this.dispatch(unmountChannelFollowers())
  }

  public updateLiveSchedules(liveSchedules: ChatRoom[]) {
    this.dispatch(updateLiveSchedules(liveSchedules))
  }

  public reset() {
    this.dispatch(reset())
  }
}

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ActionDispatcher(dispatch),
})

const mapStateToProps = ({
  loginData,
  pages,
  switchingUser,
}: RootState): Omit<IChannelContainerProps, "actions"> => ({
  currentUser: getCurrentUser(loginData, switchingUser),
  channel: pages.channel,
})

export const container = connect(mapStateToProps, mapDispatchToProps)
